export const canReviewAssignmentRequests = (associate, currentProject) =>
  !!currentProject &&
  !currentProject.staffing &&
  associate?.permissions?.some(permission => permission.name === 'invite_user')

export const formatAssignmentRate = rate => {
  if (typeof rate !== 'number') return '-'

  return `$${(rate / 100).toFixed(2)}`
}
